<script>
    import Icono from "../UI/Icono.svelte";
    export let motivo;
</script>

<style>
    .icono {
        background: var(--acentos);
        border-radius: var(--radio-global);
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: .25rem .33rem;
        font-size: .8em;
        margin-right: 1em;
    }

    .icono.actividad {
        background: var(--verde);
    }
</style>

<div class="icono" class:actividad={motivo.tipo === 'Actividad'}
     class:ausencia={motivo.tipo === 'Ausencia'}>
    <Icono svg={motivo.icono} tamano={40} margen externo/>
</div>
